/**
 * Welle 120 — Text vor/nach den Positionen als einzelne Textfelder (statt eines großen Felds): „＋ Baustein" und
 * „+ Textfeld" legen je ein NEUES Feld an, jedes Feld lässt sich einzeln als Baustein speichern, verschieben und
 * entfernen. Die Anrede steht in einem eigenen Feld — Bausteine werden ohne Anrede eingefügt und gespeichert.
 */
import React from "react";
import BausteinWahl from "./BausteinWahl";
import { ohneAnrede } from "./hilfen";
import Ico from "./Ico";

export default function TextFelder({ felder = [], setFelder, bausteine, ladeBausteine, gesperrt, standard = "" }) {
  const aendern = (i, v) => setFelder((l) => l.map((t, j) => (j === i ? v : t)));
  const weg = (i) => setFelder((l) => l.filter((_, j) => j !== i));
  const schieben = (i, d) => setFelder((l) => {
    const j = i + d;
    if (j < 0 || j >= l.length) return l;
    const n = [...l]; [n[i], n[j]] = [n[j], n[i]]; return n;
  });
  const dazu = (text) => setFelder((l) => {
    const t = ohneAnrede(text);
    // nur der unveränderte Standardtext da (z. B. „für die folgenden Leistungen …") → durch den Baustein ersetzen
    if (t && l.length === 1 && standard && String(l[0]).trim() === standard.trim()) return [t];
    return [...l.filter((x) => String(x || "").trim()), t];
  });

  return (
    <div className="rg-textfelder">
      {felder.map((t, i) => (
        <div className="rg-textfeld" key={i}>
          <textarea className="mb-input rg-area" rows={Math.min(8, Math.max(2, String(t || "").split("\n").length + 1))}
            value={t} onChange={(e) => aendern(i, e.target.value)} />
          {!gesperrt && (
            <div className="rg-textfeld-knoepfe">
              <BausteinWahl bausteine={bausteine} nurSpeichern aktuellerText={t} onGespeichert={ladeBausteine} />
              <span className="rg-textfeld-rechts">
                <button type="button" className="mb-link" title="nach oben" onClick={() => schieben(i, -1)}><Ico n="hoch" /></button>
                <button type="button" className="mb-link" title="nach unten" onClick={() => schieben(i, 1)}><Ico n="runter" /></button>
                <button type="button" className="mb-link" title="Textfeld entfernen" onClick={() => weg(i)}><Ico n="schliessen" /></button>
              </span>
            </div>
          )}
        </div>
      ))}
      {!gesperrt && (
        <div className="rg-textfeld-neu">
          <button type="button" className="mb-link" onClick={() => setFelder((l) => [...l, ""])}><Ico n="plus" /> Textfeld</button>
          <BausteinWahl bausteine={bausteine} nurEinfuegen onEinfuegen={dazu} onGespeichert={ladeBausteine} />
        </div>
      )}
    </div>
  );
}
